<template>
  <b-col>
    <template v-if="!hideName">
      <p class="mb-0"><b>{{name || 'Qualifications'}}</b></p>
    </template>
    <p
      v-for="({ name, date }) in (value || [])"
      :key="name"
      style="line-height: 1.2rem"
    >
      <span>{{ name }}</span>
      <template v-if="date">
        <br><span class="text-muted">{{ formatDate(date, 'MMM YYYY') }}</span>
      </template>
    </p>
  </b-col>
</template>

<script>
import formatDate from 'date-fns/format';

export default {
  name: 'JobSkillsShow',
  props: {
    name: {
      type: String,
    },
    value: {
      type: Array,
      default: () => [],
    },
    backgroundColor: {
      type: String,
      default: '#eee',
    },
    hideName: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatDate,
  }
};
</script>



// WEBPACK FOOTER //
// src/components/profile/QualificationsShow.vue